import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase";
import { type InfoChangeRequest } from "./infoChangeRequestModel";

interface Request {
  page?: number;
  pageSize?: number;
}

interface Response {
  success: boolean;
  infoChangeRequests: InfoChangeRequest[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
}

export const swrKey = "admin_getInfoChangeRequests";

export const infoChangeRequestsFetcher = async ([_key, page, pageSize]: [
  string,
  number,
  number,
]) => {
  const functions = getFirebaseFunctions();
  const getInfoChangeRequestsFunction = httpsCallable<Request, Response>(
    functions,
    swrKey,
  );
  const res = await getInfoChangeRequestsFunction({
    page,
    pageSize,
  });
  return res.data;
};
